const axios = require('axios');
export const  getUserDeuda = async (cliendID) => {
    try {
       const nn = await axios.get(`http://170.246.85.18:120/Servicios/ServicioConsultaSaldoWeb.svc/WsCustomerBalance/WsCustomerBalance?codigo=${cliendID}`)
  return nn.data
    } catch (error) {
      console.error("entra aqui Error");

      console.error(error);
    }
  }
